<script setup>
import CustomLink from './CustomLink.vue';
import Button from './Button.vue';

const props = defineProps({
    vehicle: Object,
})

const eurFormatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

function encodeSlug(slug) {
    return encodeURIComponent(slug).toLowerCase();
}

</script>

<template>
    <CustomLink type="href" :href="'/aanbod/' + encodeSlug(vehicle.slug)">
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow hover:shadow-lg duration-300">
            <div class="relative">
                <img :src="'/storage/images/' + vehicle.images[0]" alt="auto" class="shadow aspect-[14/9] object-cover object-bottom" />
            </div>
            <div class="p-2 sm:p-2.5 md:p-4 flex flex-col">
                <h5 class="font-semibold text-gray-900 text-nowrap truncate text-xl">{{ vehicle.brand }} {{ vehicle.model }}</h5>
                <h3 class="text-nowrap truncate text-gray-900 text-lg font-normal">{{ vehicle.type }}</h3>
                <div class="flex flex-col gap-1 pt-1">
                    <div class="flex flex-row gap-1 items-center">
                        <font-awesome-icon
                            :icon="['fas', vehicle.mileage < 80000 ? 'gauge-low' : vehicle.mileage < 150000 ? 'gauge' : 'gauge-high']"
                            class="h-4 w-4" />
                        <p class="text-sm">{{ vehicle.mileage.toLocaleString() }}km</p>
                    </div>
                    <div class="flex flex-row gap-1 items-center">
                        <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M10.7426 10.7426C9.61742 11.8679 8.0913 12.5 6.5 12.5C4.9087 12.5 3.38258 11.8679 2.25736 10.7426C1.13214 9.61742 0.5 8.0913 0.5 6.5C0.5 4.9087 1.13214 3.38258 2.25736 2.25736C3.38258 1.13214 4.9087 0.5 6.5 0.5C8.0913 0.5 9.61742 1.13214 10.7426 2.25736C11.8679 3.38258 12.5 4.9087 12.5 6.5C12.5 8.0913 11.8679 9.61742 10.7426 10.7426ZM7.25 4.25C7.25 3.83516 6.91484 3.5 6.5 3.5C6.08516 3.5 5.75 3.83516 5.75 4.25V5.75H5L5 4.25C5 3.83516 4.66484 3.5 4.25 3.5C3.83516 3.5 3.5 3.83516 3.5 4.25L3.5 8.75C3.5 9.16484 3.83516 9.5 4.25 9.5C4.66484 9.5 5 9.16484 5 8.75V7.25L5.75 7.25V8.75C5.75 9.16485 6.08516 9.5 6.5 9.5C6.91484 9.5 7.25 9.16485 7.25 8.75V7.25H8.75C9.16484 7.25 9.5 6.91484 9.5 6.5V4.25C9.5 3.83516 9.16484 3.5 8.75 3.5C8.33516 3.5 8 3.83516 8 4.25L8 5.75H7.25V4.25Z"
                                fill="black" />
                        </svg>
                        <p class="text-sm">{{ vehicle.transmission }}</p>
                    </div>
                    <div class="flex flex-row gap-1 items-center">
                        <font-awesome-icon
                            :icon="['fas', vehicle.fuel === 'Elektrisch' ? 'charging-station' : 'gas-pump']"
                            class="h-4 w-4" />
                        <p class="text-sm">{{ vehicle.fuel }}</p>
                    </div>
                </div>
                <div class="flex flex-col py-2">
                    <h3 class="text-tan">{{ eurFormatter.format(vehicle.price).replace(',00', ',-') }}</h3>
                    <div class="flex flex-row items-center">
                        <div class="flex flex-row gap-2 items-center ">
                            <font-awesome-icon class="h-3.5" :icon="['fas','hand-holding-circle-dollar']" />
                            <p class="text-base text-gray-900 text-nowrap">Financiering mogelijk</p>
                        </div>
                    </div>
                </div>
                <Button type="href" :href="'/aanbod/' + encodeSlug(vehicle.slug)" class="primary-button"> Bekijk auto</Button>
            </div>
        </div>
    </CustomLink>
</template>